module.exports = __webpack_public_path__ + "static/media/share-alt-light.83c2cba4.svg";